module.exports = __webpack_public_path__ + "img/diskette.18c4a863.png";